module.exports = __webpack_public_path__ + "img/bentley-contiental-gtc.c2b54333.png";